// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from '@emotion/styled';
import { ShoppingCart } from 'lucide-react';

const StyledProductCard = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 2rem;
  background: #F9F9F9;
  border-radius: 0.5rem;

  .breadcrumb {
    font-size: 0.85rem;
    color: #888;
    margin: 0 0 0.75rem 0;
  }

  .title {
    font-size: 1.5rem;
    font-weight: 600;
    margin: 0 0 1.5rem 0;
    color: #635E56;
  }

  .body {
    display: grid;
    grid-template-columns: 1fr 1.5fr;
    gap: 2rem;
    align-items: start;
    color: #3A3A3A;
  }

  .imageWrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
  }

  .image {
    width: 100%;
    max-width: 280px;
    object-fit: contain;
  }

  .addToCart {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    width: 100%;
    max-width: 280px;
    padding: 0.75rem 1.5rem;
    background: #da1e28;
    color: #fff;
    border: none;
    border-radius: 0.375rem;
    font-size: 14px;
    cursor: pointer;
  }

  .specs {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  .specItem {
    font-size: 0.95rem;
    line-height: 1.5;
  }
`;

const ProductCard = {
  label: 'Product Card',
  fields: {
    breadcrumb: { type: 'text' },
    title: { type: 'text', contentEditable: true },
    imageUrl: { type: 'text' },
    imageAlt: { type: 'text' },
    addToCartLabel: { type: 'text' },
    specs: {
      type: 'array',
      arrayFields: {
        label: { type: 'text' },
        value: { type: 'text' },
      },
      getItemSummary: item => item.label || 'Spec',
    },
  },
  defaultProps: {
    breadcrumb: 'Laptop-uri',
    title: 'Laptop ASUS Zenbook Duo UX8406CA-QL118X',
    imageUrl: 'https://picsum.photos/seed/product/400/400',
    imageAlt: 'Product image',
    addToCartLabel: 'Adauga in Cos',
    specs: [
      { label: 'Memorie RAM', value: '32 GB LPDDR5X' },
      { label: 'Capacitate stocare', value: '1 TB SSD M.2 NVMe™ PCIe® 4.0' },
      { label: 'Greutate', value: '1.65 kg' },
      { label: 'Display', value: 'Touch screen OLED, FHD (1920 x 1200), 14.0 inci, 60Hz' },
      { label: 'Procesor', value: 'Intel® Core™ Ultra 7 255H 2.0 GHz' },
      { label: 'Conectivitate', value: 'Wi-Fi 7' },
      { label: 'Sistem de operare', value: 'Windows 11 Pro' },
    ],
  },
  render: ({ breadcrumb, title, imageUrl, imageAlt, addToCartLabel, specs }) => (
    <StyledProductCard>
      <p className="breadcrumb">{breadcrumb}</p>
      <h1 className="title">{title}</h1>
      <div className="body">
        <div className="imageWrapper">
          {imageUrl && (
            <img src={ imageUrl } alt={ imageAlt } className="image" />
          )}
          <button type="button" className="addToCart">
            <ShoppingCart size={ 18 } />
            {addToCartLabel}
          </button>
        </div>
        <ul className="specs">
          {specs.map((spec, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <li key={ i } className="specItem">
              <p>{spec.label}:</p> {spec.value}
            </li>
          ))}
        </ul>
      </div>
    </StyledProductCard>
  ),
};

export { ProductCard };
